import ReviewStep from './ReviewStep';
import enhance from './ReviewStepContainer';

const config = {
  name: 'review',
  title: 'PO Preview',
  component: enhance(ReviewStep),
};

export default config;
